import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { swalRemove } from '../../components/Swal/Swal';
import { alertError, alertSuccess } from '../../components/Toast';
import { setData } from '../../core/redux/app/Actions';
import CompanyScreen from '../../screens/Company/CompanyScreen';
import { supabase } from '../../supabaseClient';
import { loadCompaniesWithContracts } from '../../core/utils/company';

const CompanyContainer = (props) => {
  const dispatch = useDispatch()
  const [items, setItems] = useState([])
  const reloadCompany = useSelector(state => state.app.reloadCompany || false)
  const user = useSelector(state => state.app.user || {})

  useEffect(() => {
    loadData()
}, [reloadCompany])

  const loadData = async () => {
    // Check if user is super admin
    const isSuperAdmin = !!user?.isSuperAdmin;

    // Use optimized function with JOIN to avoid N+1 queries
    const companies = await loadCompaniesWithContracts({
      userId: user?.id,
      isSuperAdmin,
    });

    setItems(companies);
  }

  return (
    <CompanyScreen
      data={items}
      user={user}
      // onRemove={item => swalRemove({ withError: false, functionConfirmRemove: () => onRemove(item) })}
    />
  )
}

export default CompanyContainer